export default class ProductCard {

	constructor() {
		this.attachClickEvent();
	}

	private attachClickEvent() {

		document.addEventListener('click', (event)=> {

			const target = event.target as HTMLElement;
			if (this.shouldBeClickable(target)) {
				const container = target.closest('.c-product') || target.closest('.atb__main__product');
				const linkElement = container.querySelector('.js-product-link') as HTMLLinkElement;
				if (linkElement) {
					if (event.ctrlKey) {
						window.open(linkElement.getAttribute('href'));
					} else {
						linkElement.click();
					}
				}

			}
		});

	}

	private shouldBeClickable(target: HTMLElement) {
		return (target.closest('.c-product')
			|| target.closest('.atb__main__product'))
			&& target.tagName.toLowerCase() !== "a"
			&& target.tagName.toLowerCase() !== "button"
			&& target.tagName.toLowerCase() !== "input"
			&& target.tagName.toLowerCase() !== "select"
			&& target.tagName.toLowerCase() !== "textarea"
			&& !target.classList.contains("js-product-add")
			&& !target.closest(".js-product-add")
			&& !target.closest('.c-product.is-loading')
			&& !target.closest('.js-ignore-product-card-click')
			&& !target.classList.contains('js-ignore-product-card-click')
			&& !target.classList.contains('js-product-link')
			&& !target.closest('.js-product-link');
	}

};
